module.exports = __webpack_public_path__ + "media/images/admin/icons/plus-square-1254f9745b42217d16e8c047e1aea764.svg";